/*
 * @Author: ylq
 * @Date: 2022-11-23 12:09:13
 * @Desc: 布局的global
 * @Last Modified by: ylq
 * @Last Modified time: 2023-02-20 17:24:14
 */
export default {
  theme: 'light',
  menu: true,
  hideMenu: false,
  splitMenu: false,
  menuCollapse: false,
  menuWidth: 220,
  device: 'desktop',
  layout: 'side', //side, mix, vertical
  showBreadcrumb: false,
  showHeader: true,
  tabBar: false
};
